module.exports = __webpack_public_path__ + "img/horizontal_4_6_pp1_6005.ea9027c0.png";